const COLOR_BLACK = '#000';
const COLOR_WHITE = '#fff';

const BRIGHTNESS_BOUND = 150;

/* get RGB array from HEX color */

const getRgb = hex => {
  const num = Number.parseInt(hex.slice(1), 16);
  return [
    num >> 16, // eslint-disable-line no-bitwise
    (num >> 8) & 0x00FF, // eslint-disable-line no-bitwise
    num & 0x0000FF, // eslint-disable-line no-bitwise
  ];
};

/* get brightness level of HEX color */

const getBrightness = hex => {
  const rgb = getRgb(hex);
  return (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
};

/* get color by hash */

const colorHash = new ColorHash();
const colorByHash = str => colorHash.hex(str);

/* get contrast to HEX color */

const colorContrast = hex => (
  getBrightness(hex) >= BRIGHTNESS_BOUND ? COLOR_BLACK : COLOR_WHITE
);

/* Avatar */

angular.module('app.components')
  .directive('avatar', () => {
    return {
      replace: true,
      scope: {
        id: '@',
        name: '@',
        size: '@',
        classSize: '@',
      },
      link: (scope, element, attrs) => {
        attrs.$observe('name', name => {
          if (!name) {
            scope.title = 'N/A';
          }

          if (scope.size === 'large') {
            scope.classSize = 'user__avatar_size_large';
          }

          const words = name && name.trim().split(/\s+/, 2);
          scope.title = words ? words.map(item => item[0]).join('') : scope.title;

          const background = colorByHash(scope.id || scope.name);
          const color = colorContrast(background);
          scope.style = `color:${color}; background:${background}`;
        });
      },
      template: `
        <div class="user__avatar {{classSize}}" style="{{style}}">
          {{title}}
        </div>`,
    };
  });
